import { SELECTOR } from "./helper";

let searchForm: HTMLFormElement | null = null;

function reset() {
  searchForm = null;
}

function init() {
  const parentWrapper: HTMLDivElement = document.querySelector(SELECTOR.SEARCH_CONTAINER) as HTMLDivElement;

  if (!searchForm && parentWrapper) {
    searchForm = parentWrapper.querySelector(SELECTOR.SEARCH_FORM) as HTMLFormElement;
    const suggestLayer = parentWrapper.querySelector(SELECTOR.LAYER) as HTMLDivElement;
    const searchField = parentWrapper.querySelector(SELECTOR.SEARCH_FIELD) as HTMLInputElement;

    /*🤫*/
    if (suggestLayer) {
      window.o_util.event.delegate(
        SELECTOR.LAYER,
        "click",
        SELECTOR.SUGGEST_TERM,
        window.o_squirrel.searchSuggest.clickSearchTermAction
      );
      window.o_util.event.delegate(
        SELECTOR.LAYER,
        "click",
        SELECTOR.MODIFIED_ARROW,
        window.o_squirrel.searchSuggest.clickArrowAction
      );
      window.o_util.event.delegate(
        SELECTOR.LAYER,
        "click",
        SELECTOR.HISTORY_EDIT_BUTTON,
        window.o_squirrel.searchHistory.clickEditAction
      );
      window.o_util.event.delegate(
        SELECTOR.LAYER,
        "click",
        ".squirrel_searchHistory",
        window.o_squirrel.searchHistory.clickTermAction
      );
      window.o_util.event.delegate(
        SELECTOR.LAYER,
        "click",
        SELECTOR.HISTORY_DELETEALL,
        window.o_squirrel.searchHistory.clickDeleteAllAction
      );
      window.o_squirrel.searchSuggest.init();
      window.o_squirrel.searchHistory.init();
      window.o_squirrel.emptyStateSuggest.init();

      searchField.addEventListener("keyup", window.o_squirrel.searchSuggest.handleKeyAction);
      searchField.addEventListener("click", window.o_squirrel.searchSuggest.clickSearchFieldAction);
      searchField.addEventListener("focus", window.o_squirrel.searchSuggest.focusSearchFieldAction);
      searchField.addEventListener("focusout", window.o_squirrel.searchSuggest.focusOutSearchFieldAction);

      /*🤫*/
      /*🤫*/
      /*🤫*/
      window.o_squirrel.searchSuggest.suggest(searchField.value || "", 0, true);
    }
  }
}

export const suggestLayer = {
  init,
  reset,
};
